const rating = (movieRating) => {
    const toString = movieRating.toString()
    const validateRating = toString.length === 1 ? `${toString}.0` : toString;
    return (validateRating);
}

export default rating;